import React from 'react';

export function ReturnsTab() {
  return (
    <div className="space-y-4">
      <div className="text-sm text-muted-foreground">
        Returns analysis is coming soon. You’ll be able to view performance metrics and time‑weighted returns here.
      </div>
    </div>
  );
}
